/** @jsx jsx */
import { jsx } from "@emotion/react";
import { useIntl } from "react-intl";
import InfoTooltip from "../InfoTooltip";

export type TemplateInfoTooltipProps = {
  tooltipText: string;
};
const TemplateInfoTooltip = ({ tooltipText }: TemplateInfoTooltipProps) => {
  const { formatMessage } = useIntl();

  if (!tooltipText) return null;
  const title = formatMessage({ id: "templates.info" });
  return <InfoTooltip tooltipTitle={title} tooltipText={tooltipText} />;
};

export default TemplateInfoTooltip;
